export const apiURL = process.env.REACT_APP_API_URL
export const filesURL = process.env.REACT_APP_FILES_URL
export const sitePath = process.env.REACT_APP_SITE_PATH